











































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import { Mutations, Views, ViewModes } from '@/ts/store/Constants';
import BackButton from '@/components/HeaderButtons/BackButton.vue';
import HandButton from '@/components/HeaderButtons/HandButton.vue';
import StaffBackButton from '@/components/HeaderButtons/StaffBackButton.vue';
import StaffLanguageButton from '@/components/HeaderButtons/StaffLanguageButton.vue';
import StaffUnitButton from '@/components/HeaderButtons/StaffUnitButton.vue';
import HococoButton from '@/components/HeaderButtons/HococoButton.vue';
import HococoAddButton from '@/components/HeaderButtons/HococoAddButton.vue';

// Right buttons
import HococoEditButton from '@/components/HeaderButtons/HococoEditButton.vue';
import UserProfileButton from '@/components/HeaderButtons/UserProfileButton.vue';
import EventListButton from '@/components/HeaderButtons/EventListButton.vue';
import EventCalendarButton from '@/components/HeaderButtons/EventCalendarButton.vue';
import TenantDashboardButtons from '@/components/HeaderButtons/TenantDashboardButtons.vue';
import CorporationLogo from '@/components/HeaderButtons/CorporationLogo.vue';
import AbuseButton from '@/components/Buttons/AbuseButton.vue';
import '@/assets/css/newstyles.scss';

@Component({
    computed: {
        ...mapGetters({
            userIsLoggedIn: 'User/userIsLoggedIn',
        }),
    },
    components: {
        BackButton,
        HococoButton,
        HococoAddButton,
        HococoEditButton,
        UserProfileButton,
        EventListButton,
        EventCalendarButton,
        StaffBackButton,
        StaffUnitButton,
        HandButton,
        StaffLanguageButton,
        TenantDashboardButtons,
        CorporationLogo,
        AbuseButton,
    },
})
export default class MobileHeader extends Mixins(DeviceMethods) {
    constructor() {
        super();
    }

    get view() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    get isDashboardPage(): boolean {
        return this.$route.name === 'dashboard';
    }

    get clearHeaderShadow(): boolean {
        return this.isDashboardPage || this.$route.name === 'my-wallet';
    }

    get isStaff() {
        return this.$store.getters['User/getUser']
            ? !this.$store.getters['User/getUser'].isTenant
            : false;
    }

    get leftHeaderButton() {
        return this.$store.getters['Viewport/leftHeaderButton'];
    }

    get rightHeaderButton() {
        return this.$store.getters['Viewport/rightHeaderButton'];
    }

    get messageSearchTerms(): string {
        return this.$store.getters['Messages/getConversationSearchTerm'];
    }

    get isSearchFieldVisible() {
        return this.$store.getters['Viewport/isSearchFieldVisible'];
    }

    get searchFieldClasses(): object {
        return {
            'hococo-search-expanded': (this.messageSearchTerms !== ''),
        };
    }

    get searchFieldIconClasses(): object {
        return {
            'hococo-faded-out': (this.messageSearchTerms !== ''),
        };
    }

    get headerText() {
        return this.$store.getters['Viewport/headerText'];
    }

    get activeConversationType() {
        return this.$store.getters['Messages/getVisibleConversationsStatus'];
    }

    get conversationsMode() {
        return (this.view.viewMode === ViewModes.Messages.Conversations);
    }

    public changeConversationStatus(type: string) {
        this.$store.commit(Mutations.SET_VISIBLE_CONVERSATIONS_STATUS, type);
    }

    private handleHeaderTextClick() {
        const currentView = this.currentView.view + this.currentView.viewMode;

        switch (currentView) {
            case (Views.Messages + ViewModes.Messages.Messages):
                this.$store.commit(Mutations.SET_MESSAGES_VIEW_MODE, ViewModes.Messages.Participants);

                break;

            default:
                return;
        }
    }

    private updateSearchMessage(e: any) {
        this.$store.commit(Mutations.UPDATE_CONVERSATION_SEARCH_TERM, e.target.value);
    }
}
